'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PreviewButton = require('./components/PreviewButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PreviewButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/preview-button/index.js
// module id = 1050
// module chunks = 0